export const getCustomTypeFromUrl = (
  customTypeUrl = '',
  allCustomTypes = {}
) => {
  for (const [customType, { url }] of Object.entries(allCustomTypes)) {
    if (url === customTypeUrl) {
      return customType
    }
  }
}

export const getAllUrls = (url = '') => {
  const urlParts = url.split('/')

  return urlParts.map((el, i, arr) => {
    if (el === '' && i === 0) {
      return '/'
    }

    return arr.slice(0, i + 1).join('/')
  })
}

export default {
  getCustomTypeFromUrl,
  getAllUrls,
}
